import { Injectable } from '@angular/core';

@Injectable()
export class WindowOpenService {

  constructor() { }
  public getNativeWindow() {
       return window;
   }
}



// WEBPACK FOOTER //
// ./src/app/common/services/window-open.service.ts